export default "__VITE_ASSET__CtmOQWSC__"